import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Header from './Header';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// const header = ReactDOM.createRoot(document.getElementById('header'));
// header.render(
//   <React.StrictMode>
//     <Header />
//   </React.StrictMode>
// );